import * as React from 'react';
import { SessionServerSelectors } from '../../../../app/selectors/SessionInfoSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { useSelector } from '../../utils';
import { SiteSettingsForSiteAdminProps } from '../site-settings/ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export type NotifySiteAdminsOnThrottleSectionProps = SiteSettingsForSiteAdminProps<'notifySiteAdminsOnThrottleEnabled'>;

export function NotifySiteAdminsOnThrottleSection() {
  if (!useSelector(SessionServerSelectors.isTimeBasedGovernanceEnabled)) {
    return null;
  }

  return (
    <SettingsSection title={Messages.notifySiteAdminsOnThrottleSettingHeader()} description={Messages.notifySiteAdminsOnThrottleSettingDescription()} testId={'notify-site-admins-on-throttle-setting'}>
      <FormikCheckbox name={'settings.notifySiteAdminsOnThrottleEnabled'}
        label={Messages.notifySiteAdminsOnThrottleSettingLabel()}
        testId={'notify-site-admins-on-throttle-checkbox'}
      />
    </SettingsSection>
  );
}

export const NotifySiteAdminsOnThrottleSpec = componentRegistryEntry({
  name: 'NotifySiteAdminsOnThrottleSection',
  component: NotifySiteAdminsOnThrottleSection
});
